import type { VoucherRequest, VoucherResponse } from '~/types/on24-klient'
import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { FetchError } from 'ofetch'

export const useSetPromoCodeMutation = () => {
  const queryClient = useQueryClient()
  const app = useNuxtApp()

  return useMutation({
    mutationFn: async ({ code }: { code: string }) => {
      try {
        return await app.$api<VoucherResponse>('/promo-code', {
          method: 'POST',
          body: {
            code,
          } satisfies VoucherRequest,
        })
      } catch (error) {
        if (error instanceof FetchError) {
          if (error.statusCode === 409) {
            throw new VoucherTooManyAttemptsError(error)
          }

          if (error.statusCode === 404) {
            throw new VoucherVoidError(error)
          }
        }

        throw error
      }
    },
    onSettled() {
      queryClient.invalidateQueries({ queryKey: ['basket'] })
    },
  })
}

export const useClearPromoCodeMutation = () => {
  const queryClient = useQueryClient()
  const app = useNuxtApp()

  return useMutation({
    mutationFn: () =>
      app.$api<undefined>('/promo-code/remove', {
        method: 'POST',
      }),
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: ['basket'] })
    },
  })
}

export class VoucherTooManyAttemptsError extends Error {
  constructor(cause: Error) {
    super('Too many voucher attempts', { cause })
    this.name = 'VoucherTooManyAttemptsError'
  }
}

export class VoucherVoidError extends Error {
  constructor(cause: Error) {
    super('Voucher is void', { cause })
    this.name = 'VoucherVoidError'
  }
}
